import { UploadStatus } from '../dtos'

export class MediaUploadVideoError extends Error {
  constructor() {
    super()
    this.message = 'mediaUpload.error.video'
  }

  public getErrorType(): UploadStatus {
    return UploadStatus.ERROR
  }
}
